
define('text!templates/modules/profile/edit/account-settings-edit-form.html',[],function () { return '<div id="group-menu"></div>\n<div class="supervisor-input"></div>\n<div class="phone-input"></div>\n<div class="expiration-input"></div>\n<div class="line-with-space"></div>\n<div class="disable-calorie-goal"></div>\n<div class="calorie-goal"></div>\n';});

